import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { compose } from 'redux';

import { withIntl } from 'HOC/withIntl';
import shouldSubmit from 'utilities/shouldSubmit';
import getDefaultLanguageRequiredFieldsErrors from 'utilities/getDefaultLanguageRequiredFieldsErrors';

import AddInfoCategoryForm from '../../components/InfoCategoryForm';

import { updateInfoCategoryRequest } from '../../services/actions';
import { selectInfoCategoryForUpdate } from '../../services/selectors';
import { forms, localizableInfoCategoryFields, requiredInfoCategoryFields } from '../../services/config';

const form = forms.addInfoCategoryForm;

const validate = (values, { intl }) =>
    getDefaultLanguageRequiredFieldsErrors(
        values,
        requiredInfoCategoryFields,
        intl.formatMessage({ id: 'error.required' }),
    );

const onSubmit = (data, dispatch, { intl, id }) => {
    const confirmMessage = intl.formatMessage({ id: 'alert.submit.warn' });
    if (shouldSubmit(data, localizableInfoCategoryFields, confirmMessage)) {
        dispatch(updateInfoCategoryRequest(form, id, data));
    }
};

export default compose(
    withIntl,
    connect((state, { id }) => ({
        initialValues: selectInfoCategoryForUpdate(state, { id }),
    })),
    reduxForm({
        form,
        validate,
        onSubmit,
        enableReinitialize: true,
    }),
)(AddInfoCategoryForm);
